import EmblaCarousel from 'embla-carousel';
import { domReady, debounce, throttle } from '../modules/utils.js';

class UiCarousel extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = {
      viewport: this.querySelector('.ui-carousel-viewport'),
      slides: this.querySelectorAll('.ui-carousel-slide')
    };
    this.#initSlider();
    this.#setListeners();
  }

  disconnectedCallback() {
    this.#unsetListeners();
  }

  #setListeners() {
    document.addEventListener('uicarousel:prev', this.#onPrev);
    document.addEventListener('uicarousel:next', this.#onNext);

    // custom code
    if (this.hasAttribute('data-posts')) {
      this.carousel.on('slidesInView', () => {
        let slidesInView = this.carousel.slidesInView();
        slidesInView = slidesInView.slice(0, 2);

        this.refs.slides.forEach((slide, index) => {
          let isVisible = slidesInView.includes(index);
          slide.toggleAttribute('data-active', isVisible);
        });
      });
    }

    if (this.hasAttribute('data-timeline')) {
      this.carousel.on('scroll', throttle((emblaApi) => {
        const index = emblaApi.selectedScrollSnap() + 1;
        this.refs.slides?.forEach((slide, i) => {
          slide.toggleAttribute('data-active', i === index);
        });
      }, 200));

      this.refs.slides?.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          this.carousel.scrollTo(index - 1);
        });
      });
    }
  }

  #unsetListeners() {
    document.removeEventListener('uicarousel:prev', this.#onPrev);
    document.removeEventListener('uicarousel:next', this.#onNext);
  }

  #initSlider() {
    this.carousel = EmblaCarousel(this.refs.viewport, {
      axis: this.hasAttribute('axis') ? this.getAttribute('axis') : 'x',
      loop: this.hasAttribute('loop'),
      align: 'start',
      skipSnaps: true
    });
  }

  #onPrev = (event) => {
    if (event.detail === this.dataset.id) {
      this.carousel.scrollPrev();
    }
  };

  #onNext = (event) => {
    if (event.detail === this.dataset.id) {
      this.carousel.scrollNext();
    }
  };
}

customElements.define('ui-carousel', UiCarousel);
